import UsageIndicator from './UsageIndicator';
import { BORDER_TYPES, ORIENTATION_TYPES } from './UsageIndicator.Enums';

export default UsageIndicator;
export { BORDER_TYPES, ORIENTATION_TYPES };
